// O que aparece dentro de cada linha da lista de atendimentos (layouts
// Clássico e Foco — no Painel quem manda são as colunas, em colunasPainel.js).
//
// Nome, hora e contador de não lidas não entram: sem eles não há como saber de
// quem é a conversa nem se ela é nova, que é o mínimo para a lista servir.
export const ITENS_DO_CARTAO = [
	{ id: "avatar", rotulo: "Foto do contato", dica: "A foto de perfil do cliente, ao lado do nome." },
	{ id: "previa", rotulo: "Prévia da última mensagem", dica: "O começo da última mensagem, para saber o assunto sem abrir." },
	{ id: "seloCanal", rotulo: "Selo do canal", dica: "Ícone de por onde o cliente falou: WhatsApp, Instagram, Telegram…" },
	{ id: "seloConexao", rotulo: "Selo da conexão", dica: "Qual número ou conexão da empresa recebeu a conversa." },
	{ id: "seloFila", rotulo: "Selo do departamento", dica: "O departamento do atendimento (ex.: Vendas, Suporte)." },
	{ id: "seloAtendente", rotulo: "Selo do atendente", dica: "Quem está cuidando do atendimento agora." },
	{ id: "etiquetas", rotulo: "Etiquetas do atendimento", dica: "As etiquetas marcadas nesta conversa." },
	{ id: "etiquetasDoContato", rotulo: "Etiquetas do contato", dica: "As etiquetas do cliente, que valem em todas as conversas dele." },
	{ id: "motivoEncerramento", rotulo: "Motivo do encerramento", dica: "Nos resolvidos, o motivo escolhido ao encerrar." },
	{ id: "espera", rotulo: "Tempo de espera", dica: "Há quanto tempo o cliente espera resposta. Muda de cor se demorar." },
	{ id: "faixaDaFila", rotulo: "Faixa colorida do departamento", dica: "Uma faixa fina na borda da linha, com a cor do departamento." },
	{ id: "vendaAguardando", rotulo: "Aviso de venda aguardando", dica: "Avisa quando o cliente tem orçamento ou pagamento pendente." },
	{ id: "slaVencendo", rotulo: "Aviso de SLA prestes a vencer", dica: "Avisa quando o prazo combinado para responder está para estourar." },
	{ id: "atendimentoRecorrente", rotulo: "Qual volta é esta (2º, 3º atendimento)", dica: "Mostra que o cliente já foi atendido antes (2º, 3º…)." },
];

// Ids acrescentados depois que esta preferência já existia. Ver `comNovos` em services/prefsTickets.js.
export const ITENS_NOVOS = [
	"atendimentoRecorrente",
	"slaVencendo",
	"motivoEncerramento",
	"vendaAguardando",
	"etiquetasDoContato",
];

export const IDS_ITENS_DO_CARTAO = ITENS_DO_CARTAO.map((i) => i.id);
